"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useViewPreference = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
var get_1 = (0, tslib_1.__importDefault)(require("lodash/fp/get"));
var ViewPreferenceApiService_1 = require("../services/ViewPreferenceApiService");
var utils_1 = require("../utils");
var reducer = function (state, action) {
    switch (action.type) {
        case 'DATA_RESPONSE':
            return (0, tslib_1.__assign)((0, tslib_1.__assign)({}, state), { data: action.payload, loading: false });
        default:
            throw new Error("No reducer case for ".concat(action.type));
    }
};
var useViewPreference = function (viewId, app, viewLevel) {
    if (viewLevel === void 0) { viewLevel = 'users'; }
    var lsKey = "ViewPrefs_".concat(viewId, "_").concat(viewLevel, "_").concat(app);
    var bootstrapData = (0, utils_1.jsonParser)(localStorage.getItem(lsKey));
    var _a = (0, react_1.useReducer)(reducer, {
        loading: true,
        data: bootstrapData || null,
    }), state = _a[0], dispatch = _a[1];
    var data = state.data, loading = state.loading;
    (0, react_1.useEffect)(function () {
        var getViewPrefs = function () { return (0, tslib_1.__awaiter)(void 0, void 0, void 0, function () {
            var res, viewPrefs;
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ViewPreferenceApiService_1.ViewPreferenceApiService.get("/views/{clientId}/{userId}/".concat(viewId, "?viewLevel=").concat(viewLevel, "&app=").concat(app))];
                    case 1:
                        res = _a.sent();
                        viewPrefs = (0, get_1.default)('data[0]', res);
                        localStorage.setItem(lsKey, JSON.stringify(viewPrefs));
                        dispatch({ type: 'DATA_RESPONSE', payload: viewPrefs });
                        return [2 /*return*/];
                }
            });
        }); };
        getViewPrefs();
    }, [viewId, viewLevel, app, lsKey]);
    return { loading: loading, data: data };
};
exports.useViewPreference = useViewPreference;
